import { memo, FunctionComponent } from 'react';
import dayjs from 'dayjs';
import celendar from 'dayjs/plugin/calendar';
dayjs.extend(celendar);
import { Post } from '~components/hooks';
import { Link } from 'react-router-dom';

interface Props {
  getNews: Post;
}

export const PostItem: FunctionComponent<Props> = memo(({ getNews }) => {
  return (
    <Link className="news-sidebar-item" to={`/blog/post/${getNews?.id}`}>
      <div className="news-sidebar-item-content">
        <img
          className="news-sidebar-item-img"
          src={`https://keystone.trustunboxing.com${getNews?.background?.url}`}
          alt={getNews?.title}
          width="30"
          height="30"
        />
        <div className="news-sidebar-item-text">
          <div className="news-sidebar-item-name">{getNews?.title}</div>
          <div className="news-sidebar-item-date">
            {dayjs(getNews?.publishDate).calendar()}
          </div>
        </div>
      </div>
    </Link>
  );
});
